/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const shape: ThemeOptions = {
	shape: {
		borderRadius: 1,
	},
};
